"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unlessLocked = exports.preventEvent = exports.pluralize = exports.numberRestrictor = exports.makeTouchDependableEvents = exports.makeIncludedServices = exports.makeHeaderTitle = exports.isTouchDevice = exports.isSSR = exports.isFreeCancellation = exports.isElementOverflown = exports.getOffersStartDate = exports.getOffersByNights = exports.getImageUrls = exports.getFullUrl = exports.formatDistance = exports.formatDecimal = exports.IMAGES_TYPE = exports.IMAGES_SIZE = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _localization = require("@lt/localization");
var _date = require("./date");
/**
 * Множественное число
 * @param {number} i
 * @param {string[]} variants
 * @returns {string}
 */
var pluralize = exports.pluralize = function pluralize(i, variants) {
  var variant = 2;
  if (i % 10 === 1 && i % 100 !== 11) {
    variant = 0;
  }
  if (i % 10 >= 2 && i % 10 <= 4 && (i % 100 < 10 || i % 100 >= 20)) {
    variant = 1;
  }
  return variants[variant];
};
var IMAGES_SIZE = exports.IMAGES_SIZE = {
  SMALL: 'smallImage',
  BIG: 'thumbImage',
  BIG_X2: 'thumbImageX2',
  FULL: 'fullImage'
};
var IMAGES_TYPE = exports.IMAGES_TYPE = {
  BIG: 'topImages',
  SMALL: 'bottomImages'
};
var isTouchDevice = exports.isTouchDevice = function isTouchDevice() {
  if (isSSR) return false;
  return 'ontouchstart' in document.documentElement;
};
var makeTouchDependableEvents = exports.makeTouchDependableEvents = function makeTouchDependableEvents() {
  var touchable = isTouchDevice();
  return {
    mousedown: touchable ? 'TouchStart' : 'MouseDown',
    mousemove: touchable ? 'TouchMove' : 'MouseMove',
    mouseup: touchable ? 'TouchEnd' : 'MouseUp',
    click: 'Click',
    touch: 'TouchStart',
    wheel: touchable ? 'TouchMove' : 'Wheel',
    get: function get(name) {
      var react = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return react ? "on".concat(this[name]) : this[name].toLowerCase();
    }
  };
};
var unlessLocked = exports.unlessLocked = function unlessLocked(ctx, evt, callback) {
  if (!ctx.lock) {
    if (callback instanceof Function) callback();
    setTimeout(function () {
      ctx.lock = false;
    }, 50);
  } else {
    evt.preventDefault();
    evt.stopPropagation();
  }
};
var getImageUrls = exports.getImageUrls = function getImageUrls(img, config) {
  var list = [img.images[config.src]];
  var srcset = config.srcSet || {};
  Object.keys(srcset).forEach(function (key) {
    return list.push(img.images[srcset[key]]);
  });
  return (0, _uniq2["default"])(list);
};
var getFullUrl = exports.getFullUrl = function getFullUrl(url) {
  var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'level.travel';
  if (!url) {
    return null;
  }
  return RegExp('http[s]?://').test(url) ? url : "//".concat(domain + url);
};

/**
 * Возвращает значение не выходящее за min и max
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @return {number}
 */
var numberRestrictor = exports.numberRestrictor = function numberRestrictor(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  if (Number.isNaN(value)) {
    return 0;
  }
  if (value > max) {
    return max;
  }
  if (value < min) {
    return min;
  }
  return value;
};
var formatDecimal = exports.formatDecimal = function formatDecimal(value) {
  /**
   * Intl не везде доступен (то ли в nodejs у нас какая-то трабла толи в браузерах)
   * Вот задача в которой фиксил: https://leveltravel.atlassian.net/browse/LT-31774
   * Багов сыпалось очень много, так что не помешало бы разобраться
   * Но проверку не убирать для большей поддержки
   *
   * Лучше всего вынести либо @lt/localization, либо на худой случай в монолит
   */
  try {
    return Intl.NumberFormat('ru-RU', {
      style: 'decimal'
    }).format(value);
  } catch (err) {
    return "".concat(value);
  }
};
var formatDistance = exports.formatDistance = function formatDistance(value) {
  return value > 999 ? "".concat(value / 1000, " ").concat(_localization.i18n.t('hotel.facts.distance_km')) : "".concat(value, " ").concat(_localization.i18n.t('commonPages.distanceM'));
};
/**
 * Проверяет, влезает ли элемент в контейнер
 * @param {*} htmlElement проверяемый элемент
 * @param {*} options проверять вертикально/горизонтально
 */
var isElementOverflown = exports.isElementOverflown = function isElementOverflown(htmlElement) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    horizontal: false,
    vertical: true
  };
  var clientWidth = htmlElement.clientWidth,
    clientHeight = htmlElement.clientHeight,
    scrollWidth = htmlElement.scrollWidth,
    scrollHeight = htmlElement.scrollHeight;
  var result = false;
  if (options.vertical) {
    result = result || scrollHeight > clientHeight;
  }
  if (options.horizontal) {
    result = result || scrollWidth > clientWidth;
  }
  return result;
};
var getOffersByNights = exports.getOffersByNights = function getOffersByNights(offersForPansion, nightsCount) {
  return offersForPansion ? offersForPansion.filter(function (offer) {
    return offer.nights_count === nightsCount;
  }) : [];
};
var getOffersStartDate = exports.getOffersStartDate = function getOffersStartDate(offersForPansion) {
  return offersForPansion ? offersForPansion.start_date : '';
};

/**
 * Создает текстовую строку вида "19 сентября на 10 ночей"
 * @param {object} offers
 * @returns {string}
 */
var makeHeaderTitle = exports.makeHeaderTitle = function makeHeaderTitle(offers) {
  var _offers = (0, _slicedToArray2["default"])(offers, 1),
    offer = _offers[0];
  var nights = offer.nights_count,
    date = offer.start_date;
  var dateText = (0, _date.formatDateToDayFull)(date);
  var nightsText = pluralize(nights, [_localization.i18n.t('hotel.offer.night', {
    count: 0
  }), _localization.i18n.t('hotel.offer.night', {
    count: 1
  }), _localization.i18n.t('hotel.offer.night', {
    count: 2
  })]);
  return "".concat(dateText, " ").concat(_localization.i18n.t('filters.prices.title_on'), " ").concat(nights, " ").concat(nightsText);
};

/**
 * Добавляет в offer.included информацию об отсуствии доп кровати
 * @return {Array}
 */
var makeIncludedServices = exports.makeIncludedServices = function makeIncludedServices(offer) {
  var withoutExtraBed = (0, _get2["default"])(offer, ['misc_data', 'extra_bed']) === false;
  var included = [];
  if (withoutExtraBed) {
    included.push({
      code_name: 'without_extra_bed',
      name: _localization.i18n.t('hotel.offer.extraBed')
    });
  }
  return [].concat(included, (0, _toConsumableArray2["default"])((0, _get2["default"])(offer, ['extras', 'included']) || []));
};
var preventEvent = exports.preventEvent = function preventEvent(e) {
  e.preventDefault();
  e.stopPropagation();
};
var FREE_CANCELLATION_KINDS = ['flexible'];
var isFreeCancellation = exports.isFreeCancellation = function isFreeCancellation(cancellationPolicy) {
  return (0, _includes2["default"])(FREE_CANCELLATION_KINDS, (0, _get2["default"])(cancellationPolicy, 'kind'));
};

/**
 * SSR ли окружение
 */
var isSSR = exports.isSSR = function () {
  try {
    return !(document !== undefined);
  } catch (e) {
    return true;
  }
}();